import mvFetch from './mvFetch'
import type WebModel from '../models/WebModel'
import Logger from './Logger'

export const getAmazonAdjustments = async (
  version: string,
  { uam }: Pick<WebModel, 'uam'>
) => {
  try {
    if (uam && !window.$mediavine.web.amazonMap) {
      const url = `${window.$mediavine.web.model.launcherUrl}/amazon/${version}/adjustments`
      const map = await mvFetch.fetchJson(url)

      window.$mediavine.web.amazonMap = map
    }
  } catch (e) {
    Logger.debug('Failed to download Amazon Adjustments')
  }
}
